<!--课时资源-->
<template>
  <a-card class="pagess">
    <a-tabs default-active-key="1">
      <span slot="tabBarExtraContent" v-if="$route.query.reportFrequency">每{{ $route.query.reportFrequency || '-' }}课时生成一次报告</span>
      <a-tab-pane key="1" tab="课时">
        <a-table
          style="min-width: 800px"
          :columns="columns"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
        >
          <span slot="childCourseType" slot-scope="childCourseType">
            {{ childCourseType === 1 ? '测评课时' : childCourseType === 2 ? '训练课时' : childCourseType === 3 ? '活动课时' : '未知类型' }}
          </span>
          <div slot="estimatedTime" slot-scope="text, record">
            <span v-if="record.composeMode == 0">{{ EstimatedTime(record.estimatedTime) }}</span>
            <span v-else></span>
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="link" :disabled="text.isOverall" @click="$router.push(`/projectImpl/pMechanism/orgDetails/content?id=${text.id}`)"> 查看内容 </a-button>
          </div>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <resources-folder-view :key="folderView.key" v-model="folderView.visible" :resources="folderView.value" />
    <resources-file-view :key="fileView.key" v-model="fileView.visible" :resources="fileView.value" />
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import Api from '@/requests/apis'
import { EstimatedTime } from '@/utils/EstimatedTime'
import ResourcesFolderView from '@/pages/content/courseSeting/components/ResourcesFolderView'
import ResourcesFileView from '@/pages/content/courseSeting/components/ResourcesFileView'

const columns = [
  {
    title: '课时名称',
    dataIndex: 'name',
    key: '1',
  },
  {
    title: '课时类型',
    dataIndex: 'childCourseType',
    scopedSlots: { customRender: 'childCourseType' },
    key: '2',
  },
  {
    title: '内容数',
    dataIndex: 'contentCount',
    key: '3',
  },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
    key: 'estimatedTime',
  },
  {
    title: '描述',
    dataIndex: 'description',
    key: '4',
    ellipsis: true,
  },
  {
    title: '操作',
    key: '6',
    scopedSlots: { customRender: 'action' },
  },
]
const resourcesColumns = [
  {
    title: '资源标题',
    scopedSlots: { customRender: 'materialFileName' },
    align: 'center',
    width: 500,
  },
  { title: '类型', scopedSlots: { customRender: 'type' }, align: 'center' },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center' },
]
export default {
  name: 'courseHourResource',
  components: { ResourcesFolderView, ResourcesFileView },
  data() {
    return {
      fileTypes: ['文件夹', '文档', '图片', '音频', '视频', '压缩文件'],
      EstimatedTime,
      AliPlayer: null, // 阿里视频播放插件
      columns,
      courseHourResourceInfo: this.$store.getters['organization/getCourseHourResource'],
      tableRelevant: tableRelevant.call(this),
      searchForm: {
        name: '',
        MaterialTypes: undefined,
        enabled: true,
      },
      currentIndex: 0,
      courseList: [],
      resourcesColumns,
      resourcesTableRelevant: tableRelevant.call(this, this.getResourcesList),
      currentItem: {},
      leftLoading: false,

      folderView: {
        visible: false,
        key: Date.now(),
        value: {},
      },
      fileView: {
        visible: false,
        key: Date.now(),
        value: {},
      },
    }
  },
  mounted() {
    this.getPageList()
    if (this.$route.query.name) {
      $Bus.$emit('pageHeaderTitle', this.$route.query.name)
    }
  },
  methods: {
    showToast() {
      this.$message.destroy()
      this.$message.warning('智能推荐课时不支持查看内容')
    },
    getPageList(pageIndex) {
      console.log(this.courseHourResourceInfo)
      const params = {
        Enabled: true,
        courseId: this.courseHourResourceInfo.courseResourceId,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }

      if (this.courseHourResourceInfo.courseType == 2) {
        params.childCourseCount = this.courseHourResourceInfo.childCourseCount
      }
      this.tableRelevant.tableLoading = true
      this.$http.CourseResource.getCourseSessions(params).then((res) => {
        const { data, status, message } = res
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },

    getTable(item, index) {
      this.currentIndex = index
      this.tableRelevant.tablePagination.current = 1
      this.currentItem = item
      this.getResourcesList(1)
    },
    getResourcesList(pageIndex) {
      console.log(this.currentItem)
      const params = {
        ChildCourseIds: this.currentItem.id,
        courseId: this.courseHourResourceInfo.courseId,
        pageIndex: pageIndex || this.resourcesTableRelevant.tablePagination.current,
        pageSize: this.resourcesTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.resourcesTableRelevant.tableLoading = true
      this.$http.resourcesList
        .pagelist(params)
        .then((res) => {
          this.resourcesTableRelevant.tableLoading = false
           
            this.resourcesTableRelevant.tablePagination.total = res.data.totalCount
            this.resourcesTableRelevant.tablePagination.current = res.data.pageIndex
            this.getResourceDownloadAuthority(res.data.items)
        })
        .catch((err) => {
          this.resourcesTableRelevant.tableLoading = false
        })
    },
    // 获取资源的下载权限
    getResourceDownloadAuthority(arr) {
      let formData = new FormData()
      formData.append('organizationResourcePackageId', this.courseHourResourceInfo.courseId)
      arr.forEach((v) => {
        formData.append('courseMaterialIds', v.id)
      })
      this.$http.resourcesList.getResourceDownloadAuthority(formData).then((res) => {
        const { data } = res
        arr.forEach((v) => {
          if (data.length) {
            data.forEach((m) => {
              if (v.downloadAuthority && v.id == m.courseMaterialId && m.downloadAuthority) {
                v.status = m.downloadAuthority
              }
            })
          } else {
            v.status = false
          }
        })
        this.resourcesTableRelevant.tableDataSource = arr
      })
    },

    // 预览
    view(record) {
      if (record.materialType === 0) {
        this.folderView.key = Date.now()
        this.folderView.visible = true
        this.folderView.value = record
        return
      }
      this.fileView.visible = true
      this.fileView.value = record
      this.fileView.key = Date.now()
    },
    download(record) {
      let url = process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + record.fileResourceId
      const a = document.createElement('a')
      a.href = url
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
  },
}
</script>

<style scoped lang="less">
.pagess {
  width: 100%;
  height: 100%;
}
._content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  .left {
    width: 15%;
    min-height: 400px;
    overflow: auto;
    text-align: center;
    .item {
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #f2f2f2;
      cursor: pointer;
    }
    .active {
      color: #1890ff;
    }
    .item:nth-child(1) {
      border-top: 1px solid #f2f2f2;
    }
    .loadingBox {
      width: 100%;
      min-height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .right {
    width: 83%;
  }
}
</style>
